module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "search-history-container",
    on: {
      "mouseenter": _vm.handleMouseEnter,
      "mouseleave": _vm.handleMouseLeave
    }
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-input', {
    ref: "searchInput",
    staticClass: "search-input",
    attrs: {
      "placeholder": _vm.placeholder,
      "clearable": ""
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "clear": _vm.handleClear,
      "input": _vm.handleInput
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleEnter($event)
      }
    },
    model: {
      value: (_vm.localKeyword),
      callback: function($$v) {
        _vm.localKeyword = $$v
      },
      expression: "localKeyword"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search search-icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })]), _vm._v(" "), _vm._t("search-button", null, {
    "keyword": _vm.localKeyword,
    "performSearch": _vm.performSearch
  })], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showHistory),
      expression: "showHistory"
    }],
    ref: "historyDropdown",
    staticClass: "search-history-dropdown",
    on: {
      "mouseenter": _vm.handleDropdownMouseEnter,
      "mouseleave": _vm.handleDropdownMouseLeave
    }
  }, [_c('div', {
    staticClass: "history-container"
  }, [(_vm.searchHistory.length > 0) ? _c('div', {
    staticClass: "history-section"
  }, [_c('div', {
    staticClass: "history-header"
  }, [_c('i', {
    staticClass: "el-icon-time history-header-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "history-title"
  }, [_vm._v("最近搜索")]), _vm._v(" "), _c('el-button', {
    staticClass: "clear-btn",
    attrs: {
      "type": "text",
      "size": "mini"
    },
    on: {
      "click": _vm.clearHistory
    }
  }, [_vm._v("\n              清空\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "history-tags"
  }, _vm._l((_vm.searchHistory), function(item, index) {
    return _c('div', {
      key: 'history-' + index,
      staticClass: "history-item",
      on: {
        "click": function($event) {
          return _vm.selectHistoryItem(item)
        }
      }
    }, [_c('span', {
      staticClass: "history-text"
    }, [_vm._v(_vm._s(_vm.formatText(item, 8)))])])
  }), 0)]) : (_vm.showHistory) ? _c('div', {
    staticClass: "history-section"
  }, [_c('div', {
    staticClass: "history-header"
  }, [_c('i', {
    staticClass: "el-icon-time history-header-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "history-title"
  }, [_vm._v("最近搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "no-data-tip"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('span', [_vm._v("暂无搜索历史")])])]) : _vm._e(), _vm._v(" "), (_vm.frequentSearches.length > 0) ? _c('div', {
    staticClass: "history-section"
  }, [_c('div', {
    staticClass: "history-header"
  }, [_c('i', {
    staticClass: "el-icon-star-on history-header-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "history-title"
  }, [_vm._v("个人常用搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "history-tags"
  }, _vm._l((_vm.frequentSearches), function(item, index) {
    return _c('el-tag', {
      key: 'frequent-' + index,
      staticClass: "history-tag frequent-tag",
      class: _vm.getAnimatedClass(item.frequency, index),
      on: {
        "click": function($event) {
          return _vm.selectFrequentItem(item)
        }
      }
    }, [(index < 3) ? _c('span', {
      staticClass: "animated-rank"
    }, [_vm._v(_vm._s(index + 1))]) : _vm._e(), _vm._v(" "), (item.frequency > 0.7) ? _c('i', {
      staticClass: "el-icon-star animated-star"
    }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.formatText(item.keyword, 8)) + "\n              "), (index < 3 && item.frequency > 0.5) ? _c('span', {
      staticClass: "sparkle",
      class: 'sparkle-' + (index + 1)
    }) : _vm._e()])
  }), 1)]) : (_vm.showHistory) ? _c('div', {
    staticClass: "history-section"
  }, [_c('div', {
    staticClass: "history-header"
  }, [_c('i', {
    staticClass: "el-icon-star-on history-header-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "history-title"
  }, [_vm._v("个人常用搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "no-data-tip"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('span', [_vm._v("暂时没有个人常用搜索历史，等待稍后更新")])])]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eae8a2f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/productMag/productSelectHost.vue
// module id = 1025
// module chunks = 3